import React from 'react';
import { UserCircle } from 'lucide-react';
import InputField from '../../../components/Forms/Input/InputField';
import { IUserForm } from '../../../types/user/userInterfaces';

interface Props {
  form: IUserForm;
  onChange: (field: string, value: any) => void;
  errors: Record<string, string>;
}

const UserBasicInfo: React.FC<Props> = ({ form, onChange, errors }) => {
  return (
    <section className="rounded-xl border border-stroke bg-white p-5 dark:border-strokedark dark:bg-boxdark-2">
      <div className="mb-4 flex items-center gap-2">
        <UserCircle className="h-5 w-5 text-primary" />
        <h3 className="text-base font-semibold text-black dark:text-white">
          Información básica
        </h3>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <InputField
          label="Nombre de Usuario"
          name="username"
          type="text"
          iconKey="user"
          value={form.username}
          onChange={(e) => onChange('username', e.target.value)}
          placeholder="Ingrese el nombre de usuario"
          error={errors.username}
          required
        />

        <InputField
          label="Correo Electrónico"
          name="email"
          type="email"
          iconKey="email"
          value={form.email}
          onChange={(e) => onChange('email', e.target.value)}
          placeholder="Ingrese el correo electrónico"
          error={errors.email}
          required
        />
      </div>
    </section>
  );
};

export default UserBasicInfo;
